var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _g, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRatingTopImg = function SvgRatingTopImg(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 203,
    height: 173,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "#CACACA",
    d: "M97.516 151.374c53.856 0 97.515-1.808 97.515-4.038s-43.659-4.038-97.515-4.038S0 145.106 0 147.336s43.66 4.038 97.516 4.038M192.164 169.343c0 1.583-12.59 2.866-28.118 2.866s-28.119-1.283-28.119-2.866 12.591-2.866 28.119-2.866 28.118 1.283 28.118 2.866",
    opacity: 0.18,
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CACACA",
    d: "M159.359 153.196c0 1.583-12.591 2.866-28.119 2.866s-28.119-1.283-28.119-2.866c0-1.582 12.591-2.866 28.119-2.866s28.119 1.284 28.119 2.866",
    opacity: 0.18,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M126.984 4.585H52.357a8.07 8.07 0 0 0-8.07 8.071v126.623a8.07 8.07 0 0 0 8.07 8.071h74.627a8.07 8.07 0 0 0 8.071-8.071V12.656a8.07 8.07 0 0 0-8.071-8.071"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#EFF0F7",
    d: "M127.755 19.003H48.796v113.556h81.11V19.003z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#DDD",
    d: "M94.3 141.974a4.957 4.957 0 1 0-9.66-2.224 4.957 4.957 0 0 0 9.66 2.224M77.113 11.992a1.518 1.518 0 1 1-3.036-.001 1.518 1.518 0 0 1 3.036.001M107.352 13.067h-26.88a1.163 1.163 0 0 1-1.157-1.157c0-.634.522-1.156 1.156-1.156h26.881c.634 0 1.157.522 1.157 1.156s-.523 1.157-1.157 1.157"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#D3B25A",
    d: "m192.109 98.483-3.272 12.459a3.63 3.63 0 0 0 1.547 3.977l10.841 6.965c3.14 2.019 1.862 6.874-1.862 7.087l-12.859.736a3.625 3.625 0 0 0-3.303 2.704l-3.272 12.459c-.949 3.606-5.96 3.896-7.315.421l-4.677-12.003a3.63 3.63 0 0 0-3.592-2.308l-12.859.736c-3.724.213-5.55-4.464-2.659-6.828l9.974-8.158a3.64 3.64 0 0 0 1.085-4.129l-4.677-12.002c-1.354-3.475 2.531-6.656 5.672-4.642l10.84 6.965a3.63 3.63 0 0 0 4.261-.243l9.974-8.157c2.886-2.364 7.112.35 6.163 3.961z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#ECC649",
    d: "m191.769 97.281-3.272 12.459a3.63 3.63 0 0 0 1.547 3.977l10.841 6.965c3.14 2.019 1.862 6.874-1.862 7.087l-12.859.736a3.625 3.625 0 0 0-3.303 2.704l-3.272 12.459c-.948 3.606-5.96 3.895-7.315.421l-4.677-12.003a3.63 3.63 0 0 0-3.592-2.308l-12.859.736c-3.724.213-5.55-4.465-2.658-6.828l9.973-8.158a3.635 3.635 0 0 0 1.085-4.129l-4.677-12.002c-1.354-3.475 2.532-6.656 5.672-4.642l10.84 6.965a3.63 3.63 0 0 0 4.262-.243l9.973-8.158c2.886-2.364 7.112.35 6.163 3.962z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M167.49 103.186a47 47 0 0 1 3.577 1.684c.147.076.294.152.431.213l.208.102.213.081c.284.117.583.188.883.248a5 5 0 0 0 1.811.036 5.2 5.2 0 0 0 1.719-.563c.269-.142.533-.304.771-.497l.183-.142.188-.158.38-.314c1.015-.837 2.044-1.654 3.135-2.41a45 45 0 0 1-2.699 2.892c-.238.233-.446.461-.72.695a6 6 0 0 1-.847.624 5.7 5.7 0 0 1-1.984.7c-.7.096-1.42.076-2.105-.091a6.3 6.3 0 0 1-.994-.345l-.239-.112-.228-.127c-.157-.086-.289-.177-.431-.264-1.106-.71-2.202-1.44-3.252-2.247zM162.392 98.789c-.609-.31-1.207-.65-1.801-1-.076-.045-.152-.086-.218-.126l-.106-.061-.107-.05a3 3 0 0 0-.421-.173 2.5 2.5 0 0 0-.807-.142c-.253 0-.492.04-.69.132a1 1 0 0 0-.273.167l-.061.05-.061.061-.127.112c-.34.305-.69.599-1.075.862.248-.395.527-.755.816-1.105.076-.092.137-.178.229-.264.086-.086.187-.157.294-.218.223-.122.492-.173.786-.178.299.005.619.061.944.188.162.066.324.137.487.223l.121.066.117.076c.081.05.152.101.223.147.584.396 1.162.797 1.73 1.233M152.414 123.974c-.574.371-1.167.721-1.766 1.061-.076.04-.152.086-.218.127l-.101.06-.097.066a4 4 0 0 0-.36.279 2.3 2.3 0 0 0-.522.629 1.5 1.5 0 0 0-.229.665c-.01.112-.01.218.01.325l.016.081.02.081.035.167c.097.447.173.898.208 1.36-.218-.411-.39-.832-.552-1.263-.041-.112-.087-.208-.112-.33a1.1 1.1 0 0 1-.041-.365c.005-.254.097-.513.239-.771a2.8 2.8 0 0 1 .634-.721c.137-.106.279-.213.436-.309l.117-.071.122-.066c.081-.046.162-.081.243-.122a35 35 0 0 1 1.933-.883z",
    opacity: 0.53
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#F2F1F1",
    d: "m92.859 34.273 4.291 12.145a3.63 3.63 0 0 0 3.516 2.42l12.88-.33c3.728-.097 5.402 4.636 2.44 6.909l-10.227 7.837a3.63 3.63 0 0 0-1.213 4.094l4.292 12.145c1.243 3.52-2.739 6.574-5.813 4.459l-10.613-7.305a3.625 3.625 0 0 0-4.266.111l-10.227 7.838c-2.963 2.267-7.097-.578-6.037-4.155L75.55 68.09a3.63 3.63 0 0 0-1.42-4.023l-10.613-7.305c-3.074-2.115-1.644-6.93 2.085-7.026l12.88-.33a3.63 3.63 0 0 0 3.389-2.597l3.667-12.352c1.06-3.577 6.083-3.708 7.326-.188z",
    opacity: 0.93,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#ECC649",
    d: "M162.575 145.077c-24.918-2.46-43.424-.391-46.66.015a6 6 0 0 0-.508.066c-2.115.401-3.733 2.273-3.733 4.5a4.59 4.59 0 0 0 4.581 4.581h46.315a4.593 4.593 0 0 0 4.581-4.581 4.593 4.593 0 0 0-4.581-4.581z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#rating_top_img_svg__a)",
    d: "M138.311 154.239s-6.955-1.02-6.615-5.26 7.295-5.089 7.295-5.089-19.51-.507-22.224 4.074 9.501 6.955 21.544 6.275"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#rating_top_img_svg__b)",
    d: "M138.991 143.889s6.108.168 6.108 5.261c0 4.256-6.787 5.088-6.787 5.088s18.003 1.705 21.103-2.628c3.099-4.327-8.366-7.36-20.424-7.721"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#DCDCDC",
    d: "M121.1 112.004H62.63c-.76 0-1.39-.624-1.39-1.39 0-.761.624-1.39 1.39-1.39h58.47c.761 0 1.39.624 1.39 1.39 0 .761-.624 1.39-1.39 1.39M121.1 117.179H62.63c-.76 0-1.39-.624-1.39-1.39 0-.761.624-1.39 1.39-1.39h58.47c.761 0 1.39.624 1.39 1.39 0 .761-.624 1.39-1.39 1.39M83.19 122.094H62.63c-.76 0-1.39-.623-1.39-1.389 0-.761.624-1.39 1.39-1.39h20.56c.761 0 1.39.624 1.39 1.39 0 .76-.623 1.389-1.39 1.389",
    opacity: 0.34,
    style: {
      mixBlendMode: "multiply"
    }
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFCF5C",
    d: "m63.664 100.626.7 1.42 1.568.228a.442.442 0 0 1 .243.756l-1.13 1.106.268 1.562c.061.361-.32.64-.644.467l-1.4-.736-1.4.736a.444.444 0 0 1-.645-.467l.27-1.562-1.132-1.106a.443.443 0 0 1 .243-.756l1.568-.228.7-1.42a.444.444 0 0 1 .797 0z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#5D5D5D",
    d: "M66.038 102.304a.43.43 0 0 1-.121.213l-1.132 1.106.27 1.563c.06.36-.32.639-.645.466l-1.4-.735-1.4.735a.44.44 0 0 1-.38.016v.03a.44.44 0 0 0 .638.467l1.4-.736 1.4.736a.444.444 0 0 0 .645-.467l-.269-1.562 1.131-1.106a.445.445 0 0 0-.137-.726",
    opacity: 0.12,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M62.594 102.004c.187-.411.38-.822.568-1.233.04-.091-.091-.167-.132-.076q-.284.617-.568 1.233c-.04.091.091.167.132.076M61.737 103.675l-.995-.923c-.07-.066-.187.035-.116.101.33.31.664.614.994.924.07.065.188-.036.117-.102",
    opacity: 0.17
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFCF5C",
    d: "m71.674 100.625.7 1.421 1.568.228a.442.442 0 0 1 .243.756l-1.131 1.106.269 1.562c.06.36-.32.64-.644.467l-1.4-.736-1.4.736a.444.444 0 0 1-.645-.467l.269-1.562-1.131-1.106a.443.443 0 0 1 .243-.756l1.568-.228.7-1.421a.445.445 0 0 1 .796 0z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#5D5D5D",
    d: "M74.048 102.304a.43.43 0 0 1-.122.213l-1.131 1.106.269 1.563c.06.36-.32.639-.644.466l-1.4-.735-1.4.735a.44.44 0 0 1-.381.016v.03a.44.44 0 0 0 .64.467l1.4-.736 1.4.736a.444.444 0 0 0 .644-.467l-.27-1.562 1.132-1.106a.445.445 0 0 0-.137-.726",
    opacity: 0.12,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M70.603 102.004q.284-.617.569-1.233c.04-.091-.092-.167-.132-.076q-.284.617-.569 1.233c-.04.091.092.167.132.076M69.746 103.675c-.33-.309-.664-.614-.994-.923-.071-.066-.188.035-.117.101.33.31.665.614.995.923.07.066.187-.035.116-.101",
    opacity: 0.17
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFCF5C",
    d: "m79.68 100.751.7 1.421 1.567.228a.442.442 0 0 1 .243.756l-1.131 1.106.269 1.562c.06.361-.32.64-.645.467l-1.4-.736-1.4.736a.444.444 0 0 1-.644-.467l.269-1.562-1.131-1.106a.443.443 0 0 1 .243-.756l1.568-.228.7-1.421a.445.445 0 0 1 .796 0z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#5D5D5D",
    d: "M82.058 102.43a.43.43 0 0 1-.122.214l-1.131 1.105.269 1.563c.06.36-.32.639-.645.467l-1.4-.736-1.4.736a.44.44 0 0 1-.38.015v.03a.44.44 0 0 0 .639.467l1.4-.736 1.4.736a.444.444 0 0 0 .644-.467l-.268-1.562 1.13-1.106a.445.445 0 0 0-.136-.726",
    opacity: 0.12,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M78.614 102.126c.188-.411.38-.822.568-1.233.04-.091-.091-.167-.132-.076-.187.411-.38.822-.568 1.233-.04.091.092.167.132.076M77.756 103.801c-.33-.309-.664-.614-.994-.923-.071-.066-.188.035-.117.101l.994.924c.072.066.188-.036.117-.102",
    opacity: 0.17
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.34,
    style: {
      mixBlendMode: "multiply"
    }
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#5D5D5D",
    d: "m88.054 100.751.7 1.421 1.568.228a.442.442 0 0 1 .243.756l-1.131 1.106.269 1.562c.06.361-.32.64-.645.467l-1.4-.736-1.4.736a.444.444 0 0 1-.644-.467l.269-1.562-1.131-1.106a.443.443 0 0 1 .243-.756l1.568-.228.7-1.421a.445.445 0 0 1 .796 0z",
    opacity: 0.34,
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5D5D5D",
    d: "M90.433 102.43a.43.43 0 0 1-.122.214l-1.131 1.105.269 1.563c.06.36-.32.639-.645.467l-1.4-.736-1.4.736a.44.44 0 0 1-.38.015v.03a.44.44 0 0 0 .639.467l1.4-.736 1.4.736a.444.444 0 0 0 .644-.467l-.268-1.562 1.13-1.106a.445.445 0 0 0-.136-.726",
    opacity: 0.12,
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5D5D5D",
    d: "M86.983 102.126q.284-.617.569-1.233c.04-.091-.092-.167-.132-.076q-.284.616-.569 1.233c-.04.091.092.167.132.076M86.131 103.801l-.994-.923c-.071-.066-.188.035-.117.101l.994.924c.072.066.188-.036.117-.102",
    opacity: 0.17,
    style: {
      mixBlendMode: "multiply"
    }
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.34,
    style: {
      mixBlendMode: "multiply"
    }
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#5D5D5D",
    d: "m96.953 100.751.7 1.421 1.567.228a.442.442 0 0 1 .244.756l-1.132 1.106.27 1.562c.06.36-.32.639-.645.467l-1.4-.736-1.4.736a.444.444 0 0 1-.644-.467l.268-1.562-1.13-1.106a.443.443 0 0 1 .243-.756l1.567-.228.7-1.421a.445.445 0 0 1 .797 0z",
    opacity: 0.34,
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5D5D5D",
    d: "M99.331 102.43a.43.43 0 0 1-.121.214l-1.132 1.105.27 1.563c.06.36-.32.639-.645.467l-1.4-.736-1.4.736a.44.44 0 0 1-.38.015v.03a.44.44 0 0 0 .638.467l1.4-.736 1.4.736a.444.444 0 0 0 .645-.467l-.269-1.562 1.131-1.106a.445.445 0 0 0-.137-.726",
    opacity: 0.12,
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5D5D5D",
    d: "M95.882 102.126c.187-.411.38-.822.568-1.233.04-.091-.091-.167-.132-.076q-.284.616-.568 1.233c-.04.091.091.167.132.076M95.03 103.801l-.995-.923c-.07-.066-.187.035-.116.101l.994.924c.07.066.188-.036.117-.102",
    opacity: 0.17,
    style: {
      mixBlendMode: "multiply"
    }
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    opacity: 0.14
  }, /*#__PURE__*/React.createElement("path", {
    d: "m44.474 55.07 93.543-44.64L106.591 0 34.166 32.994zM44.23 79.81l99.682-48.273-2.704-6.067L40.304 74.236zM38.336 130.033l111.222-61.376 3.191 13.098-82.246 41.973 73.409-31.782-87.897 46.092-15.71-.243zM134.583 61.134 44.231 121.54l90.352-56.526-1.476-3.881",
    opacity: 0.14
  }))), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M178.94 163.391c-.969-1.679-2.395-4.601-3.277-8.431-1.436-6.219-7.178-12.444-7.178-12.444-.477-5.742-3.83-22.97-3.83-23.452 0 0-4.307-8.137-7.178 1.913-2.872 10.049 5.742 19.145 5.742 22.016s13.879 22.016 13.879 22.016l-.01.025c.619-.192 1.34-.639 1.852-1.638z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#44627D",
    d: "M165.081 114.96c-4.089 0-8.431-5.098-8.431-5.098s-1.958 1.375-2.922 8.142c-.452 3.181-1.913 21.057-2.872 25.364-.943 4.236-4.195 26.511-4.301 27.257.624.395 1.527.624 2.729.106.578-2.856 1.902-8.334 3.967-11.089 2.871-3.83 1.912-11.485 2.871-13.879s4.789-18.181 8.614-20.581c5.047-3.16 1.324-10.222.345-10.222",
    opacity: 0.21,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#1B2B41",
    d: "M178.939 163.393c-.512.999-1.237 1.446-1.851 1.639l-.949 2.369s-1.435.958-2.394 1.435 2.394.959 3.348 0c.959-.959 2.871-3.83 2.871-3.83s-.426-.568-1.03-1.618z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M164.3 112.608c-4.089 0-8.432-5.098-8.432-5.098s-1.958 1.375-2.922 8.142c-.451 3.181-1.912 21.057-2.871 25.364-.943 4.236-4.195 26.511-4.302 27.257.624.395 1.527.624 2.73.106.578-2.856 1.902-8.335 3.967-11.089 2.871-3.83 1.912-11.485 2.871-13.879s4.789-18.182 8.614-20.581c5.047-3.16 1.324-10.222.345-10.222"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#1B2B41",
    d: "M145.774 168.272v.02l-3.83.959c-1.913 1.435 6.219.959 6.219.959s.112-.716.34-1.832c-1.202.518-2.105.294-2.729-.106"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "#E9BE84",
    d: "M138.879 98.293s10.486-1.852 16.284-3.14c0 0 3.845-4.535 7.766-4.114 2.527.274 6.605 2.39 1.796 4.454s-8.482 3.693-8.482 3.693l-16.857.827s-.634 2.156-1.511 2.262c-.878.107-5.641.081-5.124-.578.518-.655 3.379-1.593 3.379-1.593s-2.933.35-3.004-.233c-.071-.589 5.758-1.583 5.758-1.583"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "#A996FF",
    d: "M149.791 96.136s1.365 2.13.294 3.22c0 0 .558-.035 1.137.473.578.507 1.136.487 1.313.304s.543-.376.543-.376 4.53 1.771 10.161-1.466 6.676-5.047 5.88-6.432-1.071-3.5-5.124-2.628c-4.053.873-8.365 4.586-9.461 5.16-1.091.573-2.328.973-2.328.973s-.381-.502-.868-.309-1.202.365-1.547 1.086z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFBF9D",
    d: "M162.676 92.712s2.227-1.162 2.886-1.872c.66-.716 2.952-3.551 2.536-5.25 0 0-2.942 1.115-3.824-1.223-1.152-3.044 4.403-10.136 5.762-10.531 1.36-.396 4.378-2.237 7.214.055 2.841 2.293-1.238 12.069-4.312 12.535 0 0-3.297 5.444-2.156 7.209 0 0-4.687 1.994-6.458.69s-1.648-1.613-1.648-1.613"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#866E4F",
    d: "m167.443 86.3.66-.715s2.044-.426 2.704-1.137c0 0-1.634 2.126-3.003 2.182s-.355-.33-.355-.33z",
    opacity: 0.29,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "#423DCF",
    d: "M158.414 115.55c3.724.589 6.316.903 7.057-1.374.477-1.461.629-5.306 3.723-8.431 2.227-2.248 6.458-8.36 4.246-12.048-2.206-3.688-6.939-1.786-7.969-1.745s.918-2.785.918-2.785c-5.103 1.232-7.827 3.56-10.014 7.269-3.14 5.321-4.149 17.101-3.262 18.526l5.296.588z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#5B2A36",
    d: "M149.512 104.954s18.12 3.733 22.534-6.818c0 0 5.027-12.018 0 0l-9.121-3.561s-5.748 4.58-9.548 4.043c-3.799-.538-3.87 6.336-3.87 6.336z",
    opacity: 0.2,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "#6C543B",
    d: "M169.549 79.174a1 1 0 0 1 .543-.305.9.9 0 0 1 .659.107c.198.127.335.31.416.507.041.096.061.203.081.3.006.1.016.207 0 .309-.065-.087-.111-.168-.162-.249l-.157-.228a1.4 1.4 0 0 0-.36-.345c-.264-.167-.624-.152-1.025-.091zM166.871 77.85a.72.72 0 0 1 .386-.219.64.64 0 0 1 .467.076.77.77 0 0 1 .294.36c.025.072.04.143.056.214 0 .076.01.147 0 .218-.082-.122-.153-.239-.229-.34a1 1 0 0 0-.253-.244c-.188-.121-.442-.111-.726-.066z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "#A4A4A4",
    d: "M167.312 76.721a1.26 1.26 0 0 1 .741-.4c.142-.02.299-.061.441-.01a.7.7 0 0 1 .366.258l-.01.03c-.158.046-.285.046-.411.046-.122 0-.239-.045-.361-.055-.243-.01-.507.03-.74.152l-.026-.026zM171.842 78.598c0-.264-.086-.518-.203-.726-.065-.106-.162-.187-.213-.294-.055-.112-.111-.223-.147-.385l.021-.026c.162.02.294.102.395.203.112.102.147.259.193.396.086.279.091.583-.015.842l-.036-.01z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M167.835 75.875s-2.217-1.395-1.436-2.77c.786-1.375 2.942 0 2.942 0s-2.942-2.745-1.176-3.724c1.765-.979 5.296 1.766 5.296 1.766s-.589-1.958.786-2.547c1.375-.588 5.489 3.922 4.51 6.666 0 0 4.312 1.567.39 6.275-3.921 4.708-6.275 4.9-6.275 4.9s-.548-1.643.391-3.53c0 0 .39.786 1.177.39.786-.39 1.765-1.567 1.567-2.156-.198-.588-2.546.198-2.546.198s-.979-2.156 0-3.135 0-1.374 0-1.374-3.714.131-4.601-1.898c0 0-.371.178-1.025.939"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M173.172 80.33s-1.866 2.191-3.632 1.993c-1.765-.198-2.699-2.034-4.778-1.506 0 0-1.69 1.897-1.299 3.47.391 1.572 6.468 3.92 9.999-3.136 0 0 .208-1.045-.29-.816z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fill: "#ECF1F1",
    d: "m166.141 82.692 2.43.589s-1 .725-1.69.755c-.685.026-.74-1.344-.74-1.344"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fill: "#D3B25A",
    d: "m134.583 59.644 7.675 10.344a3.63 3.63 0 0 0 4.073 1.278l12.211-4.104c3.535-1.187 6.528 2.84 4.367 5.884l-7.467 10.496a3.63 3.63 0 0 0 .041 4.266l7.675 10.344c2.222 2.998-.685 7.087-4.246 5.971l-12.291-3.856a3.63 3.63 0 0 0-4.049 1.36l-7.467 10.496c-2.161 3.038-6.955 1.537-6.99-2.192l-.132-12.88a3.64 3.64 0 0 0-2.542-3.429l-12.291-3.855c-3.561-1.116-3.612-6.138-.076-7.325l12.21-4.104a3.64 3.64 0 0 0 2.476-3.48l-.132-12.88c-.036-3.734 4.723-5.332 6.944-2.334z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFCF5C",
    d: "m133.436 59.158 7.675 10.344a3.63 3.63 0 0 0 4.074 1.278l12.21-4.104c3.536-1.187 6.529 2.841 4.368 5.885l-7.467 10.496a3.63 3.63 0 0 0 .04 4.266l7.676 10.344c2.221 2.998-.685 7.086-4.246 5.97l-12.292-3.855a3.63 3.63 0 0 0-4.048 1.359l-7.467 10.496c-2.161 3.039-6.955 1.537-6.991-2.191l-.132-12.88a3.64 3.64 0 0 0-2.541-3.43l-12.292-3.855c-3.561-1.116-3.612-6.138-.076-7.325l12.211-4.104a3.64 3.64 0 0 0 2.475-3.48l-.132-12.88c-.035-3.734 4.723-5.332 6.945-2.334z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M122.859 81.791a48 48 0 0 1 3.551-1.74c.153-.066.305-.137.437-.203l.208-.101.197-.117a5 5 0 0 0 .746-.532 5.1 5.1 0 0 0 1.162-1.395 5 5 0 0 0 .634-1.7c.056-.3.096-.603.096-.908v-.477l-.01-.492a47 47 0 0 1 .081-3.952c.254 1.3.426 2.608.569 3.912.035.335.081.639.091.999.02.35 0 .7-.046 1.05a5.6 5.6 0 0 1-.695 1.989 5.8 5.8 0 0 1-1.385 1.588 6 6 0 0 1-.893.557l-.233.117-.243.097a8 8 0 0 1-.477.167c-1.248.421-2.501.817-3.79 1.131zM116.239 83.023c-.624.279-1.263.532-1.907.776-.081.03-.163.06-.234.091l-.111.046-.107.05a3 3 0 0 0-.395.224 2.5 2.5 0 0 0-.614.543 1.55 1.55 0 0 0-.325.619 1.1 1.1 0 0 0-.04.32v.08l.01.087.01.172c.025.457.035.913 0 1.375a11 11 0 0 1-.355-1.33c-.021-.116-.051-.217-.061-.34a1.3 1.3 0 0 1 .015-.364c.046-.249.173-.493.355-.726.193-.228.436-.441.736-.619q.227-.13.477-.238l.126-.05.132-.047a36.724 36.724 0 0 1 2.303-.66zM129.652 106.558a36 36 0 0 1-.279 2.039c-.015.086-.031.173-.036.249l-.015.116-.01.117q-.021.236-.005.457c.01.294.071.568.162.801.087.239.213.442.376.594.081.076.162.147.258.198l.071.04.076.036.153.076c.405.203.806.426 1.192.69a10 10 0 0 1-1.329-.36c-.112-.036-.213-.066-.325-.117a1.3 1.3 0 0 1-.309-.193c-.193-.162-.34-.396-.452-.67a2.8 2.8 0 0 1-.167-.943q0-.259.03-.533l.015-.137.026-.137q.023-.135.056-.263c.157-.685.319-1.37.517-2.06z",
    opacity: 0.53
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFBF9D",
    d: "M138.702 100.915s12.317-1.177 19.15-2.136c0 0 8.314-6.858 12.814-6.006 2.901.548 3.992 5.337-1.771 7.284-5.762 1.948-10.166 3.496-10.166 3.496l-19.601-.594s-.934 2.44-1.963 2.481c-1.03.04-6.544-.426-5.885-1.142.66-.715 4.058-1.537 4.058-1.537s-3.429.137-3.454-.548c-.026-.684 6.818-1.303 6.818-1.303"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fill: "#A996FF",
    d: "M153.515 99.276s1.293 2.922.162 4.129c0 0 .588-.035 1.197.528s1.197.542 1.385.335c.188-.203.573-.416.573-.416s4.789 1.968 10.729-1.603c5.941-3.572 7.036-5.58 6.194-7.113-.847-1.537-1.136-3.88-5.412-2.922-4.277.954-8.827 5.058-9.979 5.697-1.151.634-2.46 1.07-2.46 1.07s-.401-.552-.913-.344c-.513.213-1.116-.158-1.476.644z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "rating_top_img_svg__a",
    x1: 116.387,
    x2: 138.991,
    y1: 149.115,
    y2: 149.115,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D3B25A",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#D3B25A",
    stopOpacity: 0.13
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#D3B25A",
    stopOpacity: 0.36
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#D3B25A",
    stopOpacity: 0.56
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#D3B25A",
    stopOpacity: 0.72
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#D3B25A",
    stopOpacity: 0.84
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#D3B25A",
    stopOpacity: 0.93
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#D3B25A",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3B25A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "rating_top_img_svg__b",
    x1: 159.927,
    x2: 138.312,
    y1: 149.231,
    y2: 149.231,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D3B25A",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#D3B25A",
    stopOpacity: 0.13
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#D3B25A",
    stopOpacity: 0.36
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#D3B25A",
    stopOpacity: 0.56
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#D3B25A",
    stopOpacity: 0.72
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#D3B25A",
    stopOpacity: 0.84
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#D3B25A",
    stopOpacity: 0.93
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#D3B25A",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3B25A"
  })))));
};
export default SvgRatingTopImg;